import { useNavigate } from "react-router-dom";
import { api } from "../utils/apiHandler";
import { useState } from "react";

import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const ContactusComponent = () => {
  const [message, setMessage] = useState("");
  const rawHandle = localStorage.getItem("handle");
  const handle = rawHandle ? JSON.parse(rawHandle) : null;
  const { t } = useTranslation();
  const navigate = useNavigate();

  const sendMessage = async () => {
    if (!message.trim()) {
      toast.error(t("contactFailToast"), {
        position: "bottom-center",
        autoClose: 2000,
        className: "custom-toastify",
        icon: false,
      });
      return;
    }
    try {
      const payload = {
        contact: {
          user_id: handle.user.id,
          message: message,
        },
      };
      const res = await api.post("/contact", payload);
      if (res) {
        toast.success(t("contactSuccessToast"), {
          position: "bottom-center",
          autoClose: 1500,
          className: "custom-toastify",
          icon: false,
        });
        setMessage("");
      }
    } catch (error) {
      console.log(error, "Error in Sending Message");
      toast.error(t("contactFailToast"), {
        position: "bottom-center",
        autoClose: 2000,
        className: "custom-toastify",
        icon: false,
      });
    }
  };
  return (
    <div className="h-dvh w-dvw bg-bg-grey p-4 text-black">
      <div className="mt-1">
        <div onClick={() => navigate(-1)}>
          <img src="/icons/backbtn.svg" alt="" />
        </div>
        <h6 className="text-20 font-bold text-black mx-auto flex-1 text-center">
          {t("contactUs")}
        </h6>
      </div>
      <p className="text-black text-12 text-left mt-2">{t("contactMessage")}</p>
      <div className="mt-3">
        <textarea
          onChange={(e) => setMessage(e.target.value)}
          value={message}
          className="rounded-[10px] p-3 bg-white w-full h-[150px] outline-[#C11E69]"
        ></textarea>
      </div>
      <div className="mt-3">
        <button className="btn-green mx-auto uppercase" onClick={sendMessage}>
          {t("send")}
        </button>
      </div>
      <div className="mt-5">
        <div className="mt-2">
          <div className="underline text-14">{t("weAre")}</div>
          <div className="mt-2">Kalpanecha Karkhana Pvt. Ltd.</div>
        </div>
        <div className="mt-4 flex flex-col">
          <div className="underline text-14">{t("emailUs")}</div>
          <div className="flex gap-2 mt-2">
            <div>
              <img src="/icons/email.svg" alt="" />
            </div>
            <div className="text-14">support@sangati.live</div>
          </div>
        </div>
        <div className="mt-4 flex flex-col">
          <div className="underline text-14">{t("writeToUs")}</div>
          <div className="flex gap-2 mt-2">
            <div>
              <img src="/icons/location.svg" alt="" />
            </div>
            <div className="text-14">
              124/7B Saraswati Apts, Fatellal Lane, Law College Road, <br />{" "}
              Pune, Maharashtra, <br /> India PIN: 411004
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactusComponent;
